export interface TrackerData {
  id: string
  name: string
  vendor: string
  category: string
  description: string
  cookies?: ReadonlyArray<string>
  retentionDays?: number
  privacyPolicyUrl?: string
}

export class Tracker {
  readonly id: string
  readonly name: string
  readonly vendor: string
  readonly category: string
  readonly description: string
  readonly cookies: ReadonlyArray<string>
  readonly retentionDays: number | undefined
  readonly privacyPolicyUrl: string | undefined

  constructor(data: TrackerData) {
    this.id = data.id
    this.name = data.name
    this.vendor = data.vendor
    this.category = data.category
    this.description = data.description
    this.cookies = data.cookies ?? []
    this.retentionDays = data.retentionDays
    this.privacyPolicyUrl = data.privacyPolicyUrl
  }
}
